import * as React from 'react';

import { Container, Description, Header, Details, Title, ImageItem } from './newsBox.styled';
import { NewsBoxProps } from './newsBox.types';

export const NewsBox: React.FC<NewsBoxProps> = (props: NewsBoxProps) => {
  const { title, description, header, cover, type, onClick, className }: NewsBoxProps = props;

  return (
    <Container className={className} $type={type}>
      <Details $type={type}>
        <Header>{header}</Header>
        <Title onClick={onClick}>{title}</Title>
        <Description text={description} />
      </Details>
      <ImageItem $background={cover} $type={type} onClick={onClick} />
    </Container>
  );
};
